import apivarejoweb from '@/services/api-recebimentoweb';

let findTimeout = null;

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apivarejoweb.get('contacorrente', { params: { ...where, ...params } }),
        apivarejoweb.get('contacorrente/count', { params: where }),
      ]);

      return { data, total };
    },

    async findDetalhe(_, {
      where, ...params
    } = {}) {
      const data = await Promise.all([
        apivarejoweb.get('contacorrente/detalhado', { params: { ...where, ...params } }),
      ]);

      return data[0].data;
    },

    async findFluxoDeCaixa(_, {
      where, intervalo, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apivarejoweb.get(`contacorrente/fluxodecaixa/${intervalo}`, { params: { ...where, ...params } }),
        apivarejoweb.get('contacorrente/count', { params: where }),
      ]);

      return { data, total };
    },

    async findDistinct(_, {
      where,
    } = {}) {
      const [{ data }] = await Promise.all([
        apivarejoweb.get('contacorrente/distinct', { params: where }),
      ]);
      return { data };
    },

    async findCardTotal(_, {
      where,
    } = {}) {
      const [{ data }] = await Promise.all([
        apivarejoweb.get('contacorrente/resumo/total', { params: where }),
      ]);
      return { data };
    },

    async findDistinctCodigo(_, { codigo }) {
      const [{ data }] = await Promise.all([
        apivarejoweb.get(`contacorrente/distinct/${codigo}`),
      ]);
      return { data };
    },

    // CONSULTA COM CONTROLE DE CACHE
    async findWithCache({ commit, state }, { force, ttl } = {}) {
      if (!force && state.list?.length > 0) {
        return;
      }

      clearTimeout(findTimeout);

      const { data } = await apivarejoweb.get('contacorrente');

      commit('SET_LIST', data);

      if (ttl === Infinity) return;

      findTimeout = setTimeout(() => {
        commit('SET_LIST', null);
      }, ttl ?? 1000 * 60); // TTL -> Time To Live
    },

    // CONSULTA SEM CACHE
    async findById(_, { id }) {
      const { data } = await apivarejoweb.get(`contacorrente/${id}`);
      return data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
